module.exports = __webpack_public_path__ + "media/images/icons/marker-eddaaa257e75a5d5a6cc50c1972899c8.svg";